import type { AskRedoUIMessage } from "../types";
import { settlePendingToolPart } from "./settle-pending-tool-part";

/**
 * Flips a tool part parked on an earlier assistant message to
 * `output-error`, so a stale Approve/Deny card stops rendering.
 */
export function cancelStaleToolPart(
  messages: AskRedoUIMessage[],
  toolCallId: string,
  errorText: string,
): AskRedoUIMessage[] {
  return settlePendingToolPart(messages, toolCallId, {
    state: "output-error",
    errorText,
  });
}
